import {createContext} from "react";
import {IAnswersResult, IQuestion, TEST_STATUSES} from "../Tests/types";

export const PassingTestContext = createContext<{
  questions: IQuestion[];
  showResultsTest: boolean;
  minCorrectAnswerCount: number;
  percentResultTest: number;
  answersResult: IAnswersResult;
  startPassingTest: () => void;
  onResult: (testStatus: TEST_STATUSES) => void;
  getAnswersResult: (answers: IAnswersResult) => void;
  getPercentResultTest: (result: number) => void;
}>({
  questions: [],
  showResultsTest: false,
  minCorrectAnswerCount: 1,
  percentResultTest: 0,
  answersResult: {},
  getPercentResultTest: () => {},
  onResult: () => {},
  startPassingTest: () => {},
  getAnswersResult: () => {}
});
